<template>
  <div class="row">
    <form method="post" name="anonform" :class="[{ 'query-container': layoutStyle != 'bottom' }]">
      <div v-if="layoutStyle != 'bottom'" class="form-group col-sm-3"></div>
      <div :class="['form-group', { 'col-sm-6': layoutStyle != 'bottom' }]">
        <textarea class="form-control" :style="{ width: layoutStyle != 'bottom' ? '100%' : '60%' }" rows="3" :placeholder="$t('index_word2')" v-model="houseNo" ref="houseNo"></textarea>
      </div>
      <div :class="[
          'form-group',
          {
            'col-sm-3': layoutStyle != 'bottom',
            'col-sm-12': layoutStyle == 'bottom',
          },
        ]">
        <button type="button" class="btn btn-success glyphicon search_order_but" @click="sumbitForm()">
          <span class="glyphicon glyphicon-search" aria-hidden="true"></span><span>{{ $t("search") }}</span>
        </button>
        <button type="reset" name="Submit" class="btn btn-success glyphicon search_order_but btn-info " >
          <span class=" " aria-hidden="true"> 
            <img src="../../assets/img/reset.svg" style="width:17px;text-align:right;"> 
            </span><span>{{$t('reset')}}</span>
        </button>
        <!-- <button type="reset" name="Submit" class="btn btn-primary  btn-info  glyphicon search_order_but" :value="$t('reset')" >
                <img src="../../assets/img/reset.svg" style="width:15px;text-align:right;"> 
                    {{$t('reset')}}
          
        </button> -->
      </div>
    </form>
  </div>
</template>

<script>
/**
 * 空运提单查询
 */
export default {
  props: {
    layoutStyle: {
      default: "bottom",
    },
  },
  data() {
    return {
      houseNo: "",
    };
  },
  methods: {
    //提交表单
    sumbitForm() {
      if (this.houseNo === "") {
        alert(this.i18n.t("airway_bill_of_lading_least_one"));
        this.$refs.houseNo.select();
        return false;
      }

      this.$emit("query", this.houseNo);
      this.houseNo = "";
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.query-container {
  .search_order_but {
    width: 100px;
    margin-right: 10px;
    float: left;
  }
  .search_order_rest {
    float: left;
  }
}
</style>


